/**
 * PageError
 * Consistent error display for admin pages.
 */

import { AlertTriangle } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

interface PageErrorProps {
  message: string;
  onRetry?: () => void;
  className?: string;
}

export function PageError({ message, onRetry, className }: PageErrorProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-red-200 bg-red-50 p-6 text-center',
        className
      )}
    >
      <AlertTriangle className="mx-auto h-8 w-8 text-red-600 mb-3" />
      <p className="text-red-800 font-light">{message}</p>
      {onRetry && (
        <Button
          variant="outline"
          size="sm"
          className="mt-4 min-h-10 border-red-300 text-red-700 hover:bg-red-100"
          onClick={onRetry}
        >
          Reintentar
        </Button>
      )}
    </div>
  );
}
